import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { AuthRequest } from './request';
import { AuthCallback } from './callback';
import { NotFound } from '@bechtel/client-common';

const Auth = () => {
  return (
    <Routes>
      <Route element={<AuthRequest />} path="request" />
      <Route element={<AuthCallback />} path="callback" />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
export default Auth;
